import { Lang } from 'quasar';
import { t } from 'src/boot/i18n';

export function useDate(locale?: 'en-US' | 'is-IL' | 'uk-UA'  ) {
  const lang = locale || Lang.getLocale();

  function strapiDate(
    dateString: string,
    size: 'short' | 'long' = 'long',
  ): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return t('NOT_STARTED');
    }

    return date.toLocaleDateString(lang, {
      year: 'numeric',
      month: size,
      day: 'numeric',
    });
  }

  return { strapiDate };
}
